import { render } from "./AdList.vue?vue&type=template&id=486395d4"
import script from "./AdList.vue?vue&type=script&lang=js"
export * from "./AdList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__